import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appModalFocusFix]'
})
export class ModalFocusFixDirective implements AfterViewInit, OnDestroy {

  root: HTMLElement;

  constructor(el: ElementRef<HTMLElement>) {
    this.root = el.nativeElement;
  }

  private onMouseDown = (e: Event) => {
    const el = e.target as HTMLElement | null;
    if (!el) return;
    if (el.matches('[data-bs-dismiss="modal"], .btn-close')) {
      el.blur();
      (document.body as HTMLElement).focus();
    }
  };
  private onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const el = e.target as HTMLElement | null;
      if (!el) return;
      if (el.matches('[data-bs-dismiss="modal"], .btn-close')) {
        el.blur();
        (document.body as HTMLElement).focus();
      }
    }
  };
  private onHide = () => {
    const active = document.activeElement as HTMLElement | null;
    if (active && this.root.contains(active)) {
      active.blur();
      (document.body as HTMLElement).focus();
    }
  };
  private onShown = () => {
    const focusTarget =
      this.root.querySelector<HTMLElement>('[data-focus]') ??
      this.root.querySelector<HTMLElement>('.btn-close') ??
      this.root;
    focusTarget?.focus();
  };

  ngAfterViewInit(): void {
    // Early blur on activation of dismiss controls
    this.root.addEventListener('mousedown', this.onMouseDown);
    this.root.addEventListener('keydown', this.onKeyDown);
    // Bootstrap modal lifecycle hooks
    this.root.addEventListener('hide.bs.modal', this.onHide as EventListener);
    this.root.addEventListener('shown.bs.modal', this.onShown as EventListener);
  }

  ngOnDestroy(): void {
    this.root.removeEventListener('mousedown', this.onMouseDown);
    this.root.removeEventListener('keydown', this.onKeyDown);
    this.root.removeEventListener('hide.bs.modal', this.onHide as EventListener);
    this.root.removeEventListener('shown.bs.modal', this.onShown as EventListener);
  }

}
